import type { FC } from "react"
import { Outlet } from "react-router"
import { TenantFooter } from "./tenant-footer"

export const TenantAppFrame: FC = () => {
  return (
    <div className="flex min-h-screen flex-col bg-bg-white">
      <div className="flex-1">
        <Outlet />
      </div>
      <TenantFooter />
    </div>
  )
}
